export default "__VITE_ASSET__34i_HlvD__"